<template>
<div class="chapter">
<div class="inner_page">
<h1><a id="h2"></a>Acknowledgments</h1>
<p class="sectiontop">My thanks to Tom Bartlett, to Tom Bonner and WMUR-TV, and, especially, to my editors, Maureen O’Neal and Charles Spicer, for their patience and unflagging enthusiasm.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_acknow.vue?96241f08